import { ErrorText, UserEmulationFooterButtons, UserEmulationFooterContainer, } from './UserEmulation.styles';
import { Button } from '@innovyze/stylovyze/lib/components/Button';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import { userStartEmulation } from '@innovyze/stylovyze/lib/actions/userEmulation.actions';
export const UserEmulationFooter = ({ setOpen, errorMsg, }) => {
    const { t } = useGlobalization();
    const dispatch = useDispatch();
    const { values, errors, setSubmitting } = useFormikContext();
    return (React.createElement(UserEmulationFooterContainer, null,
        errorMsg && React.createElement(ErrorText, null, errorMsg),
        React.createElement(UserEmulationFooterButtons, null,
            React.createElement(Button, { onClick: () => {
                    setOpen(false);
                } }, t('Cancel')),
            React.createElement(Button, { disabled: !!errors.email || false, color: "primary", onClick: () => {
                    dispatch(userStartEmulation(values.email));
                    setSubmitting(true);
                } }, t('Begin Emulation')))));
};
